import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaTimes, FaPrint, FaCalendarAlt } from 'react-icons/fa';

const PrintInvoicesModal = ({ isOpen, onClose, storeId, baseUrl }) => {
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    useEffect(() => {
        if (!isOpen) {
            setFromDate('');
            setToDate('');
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handlePrint = () => {
        if (!storeId || !fromDate || !toDate) return;
        
        // Get auth token from session storage
        const adminData = sessionStorage.getItem('adminkhadamat');
        let token = null;
        
        if (adminData) {
            try {
                const parsed = JSON.parse(adminData);
                if (parsed.data?.token?.access_token) {
                    token = parsed.data.token.access_token;
                } else if (parsed.data?.access_token) {
                    token = parsed.data.access_token;
                } else if (parsed.data?.token) {
                    token = parsed.data.token;
                } else if (parsed.token) {
                    token = parsed.token;
                }
            } catch (error) {
            }
        }
        
        if (!token) {
            alert('يجب تسجيل الدخول أولاً');
            return;
        }
        
        // Open URL in new window
        const url = `${baseUrl}/admin/print-invoices?store_id=${storeId}&from=${fromDate}&to=${toDate}&type=download&token=${token}`;
        window.open(url, '_blank', 'noopener');
        onClose();
    };

    return (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }} onClick={onClose}>
            <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                <div className="modal-content" style={{ borderRadius: '12px', border: 'none', boxShadow: '0 10px 40px rgba(0,0,0,0.2)' }}>
                    <div className="modal-header" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white', borderTopLeftRadius: '12px', borderTopRightRadius: '12px', border: 'none' }}>
                        <h5 className="modal-title fw-bold d-flex align-items-center gap-2">
                            <FaPrint /> طباعة الفواتير
                        </h5>
                        <button type="button" className="btn btn-link text-white" onClick={onClose} aria-label="Close" style={{ textDecoration: 'none', fontSize: '1.2rem' }}>
                            <FaTimes />
                        </button>
                    </div>
                    <div className="modal-body p-4">
                        <div className="row g-4">
                            <div className="col-12">
                                <label className="form-label fw-semibold d-flex align-items-center gap-2">
                                    <FaCalendarAlt style={{ color: '#667eea' }} /> من تاريخ
                                </label>
                                <input 
                                    type="date" 
                                    value={fromDate} 
                                    onChange={(e) => setFromDate(e.target.value)} 
                                    className="form-control form-control-lg" 
                                    style={{ border: '2px solid #e9ecef', borderRadius: '8px' }}
                                />
                            </div>
                            <div className="col-12">
                                <label className="form-label fw-semibold d-flex align-items-center gap-2">
                                    <FaCalendarAlt style={{ color: '#667eea' }} /> إلى تاريخ
                                </label>
                                <input 
                                    type="date" 
                                    value={toDate} 
                                    onChange={(e) => setToDate(e.target.value)} 
                                    className="form-control form-control-lg" 
                                    style={{ border: '2px solid #e9ecef', borderRadius: '8px' }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer" style={{ borderTop: '1px solid #e9ecef' }}>
                        <button type="button" className="btn btn-outline-secondary btn-lg" onClick={onClose} style={{ borderRadius: '8px', padding: '0.5rem 2rem' }}>
                            إلغاء
                        </button>
                        <motion.button 
                            whileHover={{ scale: 1.05 }} 
                            whileTap={{ scale: 0.95 }} 
                            type="button" 
                            className="btn btn-lg d-flex align-items-center gap-2" 
                            onClick={handlePrint} 
                            disabled={!fromDate || !toDate}
                            style={{ 
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                border: 'none',
                                borderRadius: '8px',
                                padding: '0.5rem 2rem',
                                color: 'white',
                                opacity: (!fromDate || !toDate) ? 0.6 : 1,
                                cursor: (!fromDate || !toDate) ? 'not-allowed' : 'pointer'
                            }}
                        >
                            <FaPrint style={{ fontSize: '1.2rem' }} /> طباعة
                        </motion.button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrintInvoicesModal;


